import React from "react";

function Home() {
    return (
        <section className="home">
            <h1 className="animate__animated animate__slideInDown">Wel<span className="underline">come</span></h1>
            <p className="animate__animated animate__fadeIn animate__delay-1s">Hi there! I'm <b>Jason Williams</b>, also known as <b>Monsieur JAWs</b>, a recent graduate in <b>Interactive Media Design - Web from Georgian College.</b>I'm passionate about crafting beautiful, responsive websites that deliver excellent user experiences. I specialize in <b>HTML, CSS, JavaScript, and React</b>, focusing on building interactive web applications that are not only functional but also visually engaging. <b>Let's create something amazing together!</b></p>   
        </section>
    );
}

export default Home;